import { Component, Input } from "@angular/core";
import { SubscriptionHistory } from "../../../entities/index";
import { SubscriptionService } from "../../../services/subscription.service";
import { Log } from "../../../utils";

@Component({
    selector: 'app-subscription-history',
    templateUrl: './subscription-history.html'
})
export class SubscriptionHistoryComponent {
    @Input() subscriptionId: number;

    subscriptionHistories: Array<SubscriptionHistory>;

    constructor(protected subscriptionService: SubscriptionService) {}

    @Log()
    ngOnInit() {
        this.populateSubscriptionHistories();
    }

    populateSubscriptionHistories() {
        this.subscriptionService.listSubscriptionHistory(this.subscriptionId).subscribe(
            subscriptionHistories => this.subscriptionHistories = subscriptionHistories
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/blocks/subscription-history/subscription-history.component.ts